import { Button, Form, Icon, Modal } from 'antd'
import ContractsApi from '../api/Sales/SalesContracts'
import DeliveryAddressModalForm from '../elements/DeliveryAddressModalForm'
import useModalData from '../elements/Hooks/useModalData'
import React from 'react'

const api = new ContractsApi()

function DeliveryAddressModal({ fetch, contract }) {
  const { visible, submitting, submit, formRef, onShow, onCancel } = useModalData(
    (data) => api.createDeliveryAddress(contract, data),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    () => {
      fetch()
      onCancel()
    }
  )
  return (
    <>
      <Icon style={{ marginLeft: 5 }} type="plus-circle" onClick={onShow} />
      <Modal
        title="Delivery Address"
        destroyOnClose={true}
        width={'95%'}
        visible={visible}
        onOk={submit}
        onCancel={onCancel}>
        <DeliveryAddressModalForm ref={formRef} {...{ submitting, contract }} />
      </Modal>
    </>
  )
}

export default DeliveryAddressModal
